import React from 'react';
import { BrowserRouter as Router, Link } from "react-router-dom";
import { Statistic } from '../../../helpers/uiComponents';
import { getPercentChange, numberToLocal, numberToPrice, secondsToTime } from '../../../helpers/uiFunctions';

class SamplesSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sampleLeads: [],
            sampleLeadsCount: null,
            sampleLeadsWonCount: null,
            samplesLeadsWon: null,
            sampleLeadsValue: null,
            oldSampleLeadsCount: null,
        }
    }
    componentDidUpdate(prevProps) {
        try {
            if(this.props.sampleLeads && (this.props.sampleLeads !== prevProps.sampleLeads)) {
                this.setState({
                    sampleLeads: this.props.sampleLeads,
                    sampleLeadsCount: this.props.sampleLeadsCount,
                    oldSampleLeadsCount: this.props.oldSampleLeadsCount,
                });

                this.handleTotal(this.props.sampleLeads);
            }
        } catch (error) {
            console.log(error);
        }
    }

    handleTotal(leads) {
        
        let leadValue = 0;
		let wonValue = 0;
        let wonCount = 0;
		leads.forEach(function(lead) {
			leadValue = leadValue + lead.value;

			if (lead.conversionStatus === "Won") {
				wonValue = wonValue + lead.value;
                wonCount = wonCount + 1;
			}
		});
		
		this.setState({
			samplesLeadsWon: wonValue,
            sampleLeadsValue: leadValue,
            sampleLeadsWonCount: wonCount,
		});
    }
    render() {
        const { sampleLeads, sampleLeadsCount, samplesLeadsWon, sampleLeadsValue, oldSampleLeadsCount, sampleLeadsWonCount } = this.state;
        return(
            <React.Fragment>
                {(this.props.onClick) && (
                    <Router>
                        <Link to="sample-orders" className="button white learn-more" onClick={() => this.props.onClick("sample-orders")}>
                            <i className="fas fa-chart-line"></i>
                        </Link>
                    </Router>
                )}
                <h3>LEADS: SAMPLES</h3>
                <section className="stats row">
                    <Statistic
                        label="Total Sample Leads"
                        value={(sampleLeadsCount !== null) ? numberToLocal(sampleLeadsCount) : ("calculating...")}
                        status={(sampleLeadsCount !== null && oldSampleLeadsCount !== null) && getPercentChange(sampleLeadsCount, oldSampleLeadsCount)[1]}
                        percent={(sampleLeadsCount !== null && oldSampleLeadsCount !== null) && getPercentChange(sampleLeadsCount, oldSampleLeadsCount)[0]}
                        hideHistorical={this.props.hideHistorical}
                    />
                    <Statistic
                        label="Total Sample Leads Won"
                        value={(samplesLeadsWon !== null) ? numberToLocal(sampleLeadsWonCount) : ("calculating...")}
                        hideHistorical={true}
                    />
                    <Statistic
                        label="Sample Leads Return Value ($)"
                        value={(sampleLeadsValue !== null) ? numberToPrice(sampleLeadsValue) : ("calculating...")}
                        hideHistorical={"true"}
                    />
                </section>
            </React.Fragment>
        )
    }
}
export default SamplesSummary;